import React from 'react';
import MediaUploadField from './MediaUploadField';

/** Variante image du champ média unifié (voir MediaUploadField). */
const ImageUploadField = (props) => <MediaUploadField {...props} kind="image" />;

export default ImageUploadField;
